import React from "react";
import { connect } from "react-redux";
import icons from "../../constants/icons";
import "./styles.css";
import { fetchMerchantVerifications } from "../../queries/verification/merchantVerficationQuery";
import { getStorage, setStorage } from "../../utils/storage";
import { Button } from "../Button";

class BannerAlert extends React.Component {
  state = {
    alertObject: {},
    isLoading: false,
  };

  componentDidMount() {
    this.getVerifications();
  }

  getVerifications = async () => {
    try {
      const { defaultLanguage } = this.props;
      const user = await getStorage();

      this.setState({ isLoading: true });

      let data = await fetchMerchantVerifications(defaultLanguage);

      let alertObject = {};

      data?.map((el) => {
        if (el.verificationType === "KYC_DOCUMENT_VERIFICATION" && !el.status) {
          alertObject = {
            message:
              "Your account is incomplete. Click here to start KYC verification process",
            icon: icons.identification,
            onPress: () =>
              (window.location.href = "/merchant/kyc/onboarding/stepTwo"),
          };
        }

        // if (el.verificationType === "KYC_DOCUMENT_VERIFICATION" && !el.status) {
        //   alertObject = {
        //     message:
        //       "Your account is under review. We will notify you once it is reviewed",
        //     icon: icons.identification,
        //   };
        // } else if (el.verificationType === "ACCOUNT_APPROVAL" && el.status) {
        //   user["verified"] = true;
        //   setStorage(user);
        // }
      });

      this.setState({ alertObject, isLoading: false });
    } catch (error) {
      this.setState({ isLoading: false });
    }
  };

  render() {
    return (
      <>
        {this.state.alertObject.message && (
          <div className="banner-alert-container">
            <div className="icon-container">
              <span className={process.env.REACT_APP_ICONS_TYPE}>
                {this.state?.alertObject?.icon}
              </span>
            </div>
            <div
              className="banner-alert-info"
              onClick={
                this.state.alertObject.onPress
                  ? this.state.alertObject.onPress
                  : null
              }
            >
              <div style={{ flex: 1 }}>
                <span>{this.state?.alertObject.message}</span>
              </div>
              {this.state.alertObject.onPress && (
                <Button
                  text="Verify"
                  className="btn-sm"
                  onPress={this.state.alertObject.onPress}
                />
              )}
            </div>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  const { verifications } = state.Verifications;
  return {
    defaultLanguage,
    verifications,
  };
};

export default connect(mapStateToProps)(BannerAlert);
